import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../../../auth';
import { Button, Form, Modal } from 'react-bootstrap';
import Select from 'react-select';

function ModalTambahPcpDetail({
    showAddPcpDetail,
    setShowAddPcpDetail,
    listCategory,
    formStyles,
    selectStyles,
    wapu,
    onSave
}) {

    const { theme } = useContext(ThemeContext);

    const handleClose = () => {
        setShowAddPcpDetail(false);
        setProductName('');
        setSelectedCategory(null);
        setProductDesc('');
        setBuyingPrice('');
        setSellingPrice('');
        setProductDesc('');
        setQty('');
    };

    const [productName, setProductName] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [productDesc, setProductDesc] = useState('');
    const [buyingPrice, setBuyingPrice] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [qty, setQty] = useState('');

    const categoryOptions = listCategory.map(category => ({
        value: category.id,
        label: category.categoryName,
    }));

    const handleSelectedCategory = selectedOption => {
        setSelectedCategory(selectedOption);
    };

    function handleChangeBuyingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setBuyingPrice(numericValue);
    };

    function handleChangeSellingPrice(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;

        setSellingPrice(numericValue);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const calculatedSubTotal = parseFloat(sellingPrice) * parseInt(qty, 10);

        const calculatedPurchaseTotal = parseFloat(buyingPrice) * parseInt(qty, 10);

        const marginTotal = ((parseFloat(sellingPrice) - parseFloat(buyingPrice)) / parseFloat(sellingPrice)) * 100;

        let marginValidate = false;

        if (wapu === true) {
            if (selectedCategory?.value === 1) {
                marginValidate = marginTotal.toFixed(2) <= 16 ? false : true
            } else if (selectedCategory?.value === 2) {
                marginValidate = marginTotal.toFixed(2) <= 31 ? false : true
            } else if (selectedCategory?.value === 3) {
                marginValidate = marginTotal.toFixed(2) <= 41 ? false : true
            }
        } else {
            if (selectedCategory?.value === 1) {
                marginValidate = marginTotal.toFixed(2) <= 10 ? false : true
            } else if (selectedCategory?.value === 2) {
                marginValidate = marginTotal.toFixed(2) <= 20 ? false : true
            } else if (selectedCategory?.value === 3) {
                marginValidate = marginTotal.toFixed(2) <= 30 ? false : true
            }
        }

        const newData = {
            productName,
            categoryId: selectedCategory?.value || '',
            categoryName: selectedCategory?.label || '',
            productDesc: productDesc || '',
            validateMargin: marginValidate,
            buyingPrice,
            sellingPrice,
            quantity: qty,
            subtotal: calculatedSubTotal,
            purchaseCalculate: calculatedPurchaseTotal,
            margin: marginTotal.toFixed(2)
        };

        onSave(newData);

        setProductName('');
        setSelectedCategory(null);
        setProductDesc('');
        setBuyingPrice('');
        setSellingPrice('');
        setQty('');
        setShowAddPcpDetail(false);
    };

    return (
        <Modal
            show={showAddPcpDetail}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='md'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                    Tambah PCP Produk
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} >
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='productName'>Nama Produk*</Form.Label>
                        <Form.Control
                            id='productName'
                            type='text'
                            onChange={(e) => setProductName(e.target.value)}
                            value={productName}
                            required
                            placeholder='Nama Produk'
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='category'>Jenis Produk*</Form.Label>
                        <Select
                            id='category'
                            options={categoryOptions}
                            required
                            value={selectedCategory}
                            onChange={handleSelectedCategory}
                            styles={selectStyles}
                            placeholder='Pilih Jenis Produk'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='spec'>Spesifikasi</Form.Label>
                        <Form.Control
                            id='spec'
                            as='textarea'
                            rows={4}
                            onChange={(e) => setProductDesc(e.target.value)}
                            value={productDesc}
                            style={formStyles.input}
                            placeholder='Spesifikasi'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='buyingPrice'>Harga Beli*</Form.Label>
                        <Form.Control
                            id='buyingPrice'
                            type='text'
                            onChange={handleChangeBuyingPrice}
                            value={`Rp ${buyingPrice ? buyingPrice.toLocaleString('id-ID') : ''}`}
                            required
                            placeholder='Harga Beli'
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='sellingPrice'>Harga Jual*</Form.Label>
                        <Form.Control
                            id='sellingPrice'
                            type='text'
                            onChange={handleChangeSellingPrice}
                            value={`Rp ${sellingPrice ? sellingPrice.toLocaleString('id-ID') : ''}`}
                            required
                            placeholder='Harga Jual'
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='qty'>Qty*</Form.Label>
                        <Form.Control
                            id='qty'
                            type='text'
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setQty(value);
                                }
                            }}
                            value={qty}
                            required
                            style={formStyles.input}
                            placeholder='Jumlah'
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4 mb-2">
                        <Button
                            type="submit"
                            id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                            variant='btn'
                            disabled={
                                !productName ||
                                !selectedCategory ||
                                // !productDesc ||
                                !sellingPrice ||
                                !qty
                            }
                        >
                            Tambah
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahPcpDetail
